// src/components/LoadingSpinner.js
import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ 
      height: '100vh', 
      width: '100vw',
      flexDirection: 'column',
      backgroundColor: 'white'
    }}>
      {/* Logo/Texte principal */}
      {/* <div style={{
        marginBottom: '2rem',
        fontSize: '2.8rem',
        fontWeight: '800',
        color: '#28416F',
        letterSpacing: '1px',
        fontFamily: 'Arial, sans-serif'
      }}>
        eTrainApp
      </div> */}
      
      {/* Spinner centré */}
      <div className="spiner-example">
        <div className="sk-spinner sk-spinner-wave">
          <div className="sk-rect1 mr-1"></div>
          <div className="sk-rect2 mr-1"></div>
          <div className="sk-rect3 mr-1"></div>
          <div className="sk-rect4 mr-1"></div>
          <div className="sk-rect5"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;